import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable camelcase */

import { CLICKSTREAM_VIEW, CLICKSTREAM_INTERACTION } from '../constants';
import { rioEvent } from './rsw';
var isWindowDefined = typeof window !== 'undefined';
export var gtmOnLoad = function gtmOnLoad(hostCodeBase) {
  // The below line is added only for testing component in isolation
  // window.dataLayer = []

  if (isWindowDefined && window.dataLayer) {
    var sharedProps = {
      event: 'virtualPage',
      pageSubGroup: 'payment capture'
    };
    var pageGroup;
    var virtualPagePath;
    if (hostCodeBase === 'CFE') {
      pageGroup = 'core citation flow';
      virtualPagePath = '/users/redesign_payment_modal';
    } else {
      pageGroup = 'awt';
      virtualPagePath = '/users/paperchecker_payment_modal';
    }
    window.dataLayer.push(_objectSpread(_objectSpread({}, sharedProps), {}, {
      pageGroup: pageGroup,
      virtualPagePath: virtualPagePath
    }));
  }
};
export var sendClickStreamViewEvent = function sendClickStreamViewEvent(viewContext) {
  var view_name = viewContext.view_name,
    experience = viewContext.experience,
    property = viewContext.property;
  return {
    payload: {
      data: {},
      type: CLICKSTREAM_VIEW
    },
    config: {
      stateUpdate: {
        view: {
          view_name: view_name,
          experience: experience,
          property: property
        }
      }
    }
  };
};
export var sendClickStreamInteractionEvent = function sendClickStreamInteractionEvent(interactionType, viewElement) {
  var forceSend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var name = viewElement.name,
    type = viewElement.type,
    region_name = viewElement.region_name;
  return {
    payload: {
      type: CLICKSTREAM_INTERACTION,
      data: {
        interaction: {
          type: interactionType,
          element: {
            name: name,
            type: type,
            region_name: region_name
          }
        }
      }
    },
    config: {
      force: forceSend
    }
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var sendEventToRio = function sendEventToRio(event) {
  if (typeof window === 'undefined') {
    return;
  }
  var payload = event.payload,
    config = event.config;
  if (_typeof(payload) === 'object') {
    rioEvent(payload, config)["catch"](function (e) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(e);
      }
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/utils/analytics.js
// module id = 1245
// module chunks = 11